<script>
	import { scaleColor } from '../../scaleColor';

	export let commits;
	export let dark = false;
	export let color;
	export let date;

	let element;
	let height;
	let y;
	let active = false;

	const toggleActive = () => {
		if (date.length === 0) active = true;
		active = !active;
	};

	const setHeight = () => {
		if (element) height = element?.getBoundingClientRect().top;
	};

	$: y, setHeight();
</script>

<div
	class={`github-table-cell table-cell-background-${scaleColor[color]}`}
	class:active
	class:dark
	on:mouseenter={toggleActive}
	on:mouseleave={toggleActive}
	bind:this={element}
>
	<div class="github-table-cell-data" class:flex-visible={active} style="top: {height}px" class:dark>
		<h3>{commits} commits</h3>
		<p>{date}</p>
	</div>
</div>

<svelte:window bind:scrollY={y} />

<style lang="scss">
	@import '../../githubSection';
</style>
